<template>
    <div class="">
        <div class="d-sm-flex align-items-center justify-content-between mb-2">
            <div>
                <ol class="breadcrumb fs-sm mb-1">
                    <li class="breadcrumb-item" aria-current="page">
                        <router-link to="/dashboard">Dashboard</router-link>
                    </li>
                    <li class="breadcrumb-item">
                        <a href="javascript:void(0)">Masters</a>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">Assets</li>
                </ol>
                <h4 class="main-title mb-0">Assets</h4>
            </div>
            <div class="d-flex flex-wrap justify-content-end align-items-center gap-2">
                <a v-if="meta.department_id" class="btn btn-warning" v-can="'assets.download_report'" @click="downloadQRCodes">
                    <i class="ri-download-line"></i> DOWNLOAD QR Codes
                </a>
                <a class="btn btn-success" v-can="'assets.download_report'" @click="downloadExcel">
                    <i class="ri-download-line"></i> DOWNLOAD ASSETS
                </a>
                <button
                    v-if="meta.asset_type_id"
                    type="button"
                    class="btn btn-outline-primary"
                    v-can="'assets.download_report'"
                    @click="downloadAssetFormat"
                >
                    <i class="ri-download-line"></i> DOWNLOAD FORMAT
                </button>
                <div v-can="'assets.create'" class="d-inline-flex align-items-center gap-2">
                    <label for="uploadAssetFile" class="btn btn-secondary mb-0" style="cursor: pointer;">
                        <i class="ri-file-line"></i> CHOOSE FILE
                    </label>
                    <input
                        type="file"
                        id="uploadAssetFile"
                        ref="uploadAssetFile"
                        class="d-none"
                        accept=".xlsx,.xls,.csv"
                        @change="onAssetFileSelect"
                    />
                    <span v-if="selectedFileName" class="text-muted small" :title="selectedFileName">{{ selectedFileName }}</span>
                    <button v-if="selectedFileName" type="button" class="btn btn-info" @click="uploadAssetExcel">
                        <i class="ri-upload-line"></i> UPLOAD ASSET
                    </button>
                </div>
                <button
                    v-if="canDownloadPlantAssetsExcel"
                    type="button"
                    class="btn btn-outline-success"
                    @click="downloadPlantAssetsExcel"
                >
                    <i class="ri-download-line"></i> ASSETS (no parameters)
                </button>
                <router-link to="/asset/create" v-can="'assets.create'" class="btn btn-primary">
                    <i class="ri-list-check"></i> ADD ASSET
                </router-link>
            </div>

        </div>
        <div class="row">
            <div class="col-12">
                <div class="card card-one">
                    <div class="card-header d-flex justify-content-between">
                        <h6 class="card-title">Assets</h6>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-3">
                                <select 
                                    class="form-control form-control-sm mb-2" 
                                    :class="{'is-invalid': errors?.department_id}" 
                                    v-model="meta.department_id" 
                                    @change="search()">
                                    <option value="">Select Department</option>
                                    <option v-for="department, key in departments" :key="key" :value="department.department_id">
                                        {{ department.department_name }}
                                    </option>
                                </select>
                                <span v-if="errors?.department_id" class="invalid-feedback">
                                    {{ errors.department_id[0] }}
                                </span>
                            </div>
                            <div class="col-md-3">
                                <select
                                    class="form-control form-control-sm mb-2"
                                    :class="{'is-invalid': errors?.asset_type_id}"
                                    v-model="meta.asset_type_id"
                                    @change="search()"
                                >
                                    <option value="">Select Asset Type</option>
                                    <option v-for="assetType, key in asset_types" :key="key" :value="assetType.asset_type_id">
                                        {{ assetType.asset_type_name }}
                                    </option>
                                </select>
                                <span v-if="errors?.asset_type_id" class="invalid-feedback">
                                    {{ errors.asset_type_id[0] }}
                                </span>
                            </div>
                            <div class="col-md-6">
                                <input class="form-control form-control-sm mb-2" type="text" placeholder="Type keyword and press enter key" v-model="meta.search" @keypress.enter="search()" />
                            </div>
                        </div>
                        
                        <div class="table-responsive table-responsive-sm">
                            <table class="table table-sm text-nowrap table-striped table-bordered mb-0">
                                <thead>
                                    <tr class="" style="background-color: #9b9b9b; color: white;">
                                        <th class="text-center">#</th>
                                        <th @click="sort('asset_type_name')">
                                            Asset Type
                                            <span>
                                                <i v-if="meta.keyword == 'asset_type_name' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                                <i v-else-if="meta.keyword == 'asset_type_name' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                                <i v-else class="fas fa-sort"></i>
                                            </span>
                                        </th>
                                        <th @click="sort('department_name')">
                                            Department
                                            <span>
                                                <i v-if="meta.keyword == 'department_name' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                                <i v-else-if="meta.keyword == 'department_name' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                                <i v-else class="fas fa-sort"></i>
                                            </span>
                                        </th>
                                        <th>
                                            Section
                                            <span>
                                                <i v-if="meta.keyword == 'section_name' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                                <i v-else-if="meta.keyword == 'section_name' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                                <i v-else class="fas fa-sort"></i>
                                            </span>
                                        </th>
                                        <th @click="sort('asset_code')">
                                            Asset Code
                                            <span>
                                                <i v-if="meta.keyword == 'asset_code' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                                <i v-else-if="meta.keyword == 'asset_code' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                                <i v-else class="fas fa-sort"></i>
                                            </span>
                                        </th>
                                        <th @click="sort('asset_name')">
                                            Asset Name
                                            <span>
                                                <i v-if="meta.keyword == 'asset_name' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                                <i v-else-if="meta.keyword == 'asset_name' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                                <i v-else class="fas fa-sort"></i>
                                            </span>
                                        </th>
                                        <th @click="sort('latitude')">
                                            Latitude
                                            <span>
                                                <i v-if="meta.keyword == 'latitude' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                                <i v-else-if="meta.keyword == 'latitude' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                                <i v-else class="fas fa-sort"></i>
                                            </span>
                                        </th>

                                        <th @click="sort('longitude')">
                                            Longitude
                                            <span>
                                                <i v-if="meta.keyword == 'longitude' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                                <i v-else-if="meta.keyword == 'longitude' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                                <i v-else class="fas fa-sort"></i>
                                            </span>
                                        </th>

                                        <th @click="sort('radius')">
                                            Radius
                                            <span>
                                                <i v-if="meta.keyword == 'radius' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                                <i v-else-if="meta.keyword == 'radius' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                                <i v-else class="fas fa-sort"></i>
                                            </span>
                                        </th>
                                        <th @click="sort('created_at')">
                                            Created At
                                            <span>
                                                <i v-if="meta.keyword == 'created_at' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                                <i v-else-if="meta.keyword == 'created_at' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                                <i v-else class="fas fa-sort"></i>
                                            </span>
                                        </th>
                                        <!-- <th @click="sort('serial_no')">
                                            Serial No.
                                            <span>
                                                <i v-if="meta.keyword == 'serial_no' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                                <i v-else-if="meta.keyword == 'serial_no' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                                <i v-else class="fas fa-sort"></i>
                                            </span>
                                        </th> -->
                                        <th class="text-center" v-can="'assets.delete'">Status</th>
                                        <th class="text-center" v-if="get_assetviews.length || get_asset.length">Actions</th>
                                        <th class="text-center" v-if="goto_registers.length">GoTo</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="asset, key in assets" :key="key">
                                        <td class="text-center">{{ meta.from + key }}</td>
                                        <td>{{ asset?.asset_type?.asset_type_name }}</td>
                                        <td>{{asset?.department?.department_name}}</td>
                                        <td>{{asset?.section?.section_name}}</td>
                                        <td>{{asset.asset_code}}</td>
                                        <td>{{asset.asset_name}}</td>
                                        <td>{{asset?.latitude}}</td>
                                        <td>{{asset?.longitude}}</td>
                                        <td>{{asset?.radius}}</td>
                                        <td>{{asset.created_at}}</td>
                                        <!-- <td>{{asset.serial_no}}</td> -->
                                        <td class="text-center" v-can="'assets.delete'">
                                            <div class="form-switch">
                                                <input class="form-check-input" type="checkbox" role="switch" :id="'asset' + asset.asset_id" :checked="asset.status" :value="asset.status" @change="deleteAsset(asset)" />
                                                <label class="custom-control-label" :for="'asset' + asset.asset_id"></label>
                                            </div>
                                        </td>
                                        <td class="text-center" v-if="get_assetviews.length || get_asset.length">
                                            <a
                                                v-can="'assetLocations.update'"
                                                title="Update Location"
                                                href="javascript:void(0)"
                                                class="text-info me-2"
                                                @click.prevent="openLocationModal(asset)"
                                            >
                                                <i class="ri-map-pin-line fs-18 lh-1"></i>
                                            </a>
                                            <a v-can="'assets.update'" title="Edit" href="javascript:void(0)" class="text-success me-2" v-if="asset.status" @click="editAsset(asset)"><i class="ri-pencil-line fs-18 lh-1"></i></a>
                                            <a v-can="'assetviews.details'" title="View" href="javascript:void(0)" class="text-primary me-2" @click.prevent="viewAsset(asset)"><i class="ri-eye-fill fs-18 lh-1"></i></a>
                                            <a href="javascript:void(0)" title="QR code" class="text-dark me-2" @click.prevent="getQRCode(asset)"><i class="ri-qr-code-line fs-18 lh-1"></i></a>
                                             <a v-can="'asset_permanent.delete'" title="Asset Delete" href="javascript:void(0)" class="text-danger me-2" @click.prevent="forceDeleteAsset(asset)"><i class="ri-delete-bin-6-line fs-18 lh-1"></i></a>
                                        </td>
                                        <td class="text-center" v-if="goto_registers.length">
                                            <a v-can="'activity_registers.create'" title="Activity Register" href="javascript:void(0)" class="text-primary me-2" @click.prevent="viewRegister(asset, '/activity/create')"><i class="ri-stack-fill fs-18 lh-1"></i></a>
                                            <a v-can="'service_registers.create'" title="Service Register" href="javascript:void(0)" class="text-primary me-2" @click.prevent="viewRegister(asset, 'user_service/create')"><i class="ri-tools-fill fs-18 lh-1"></i></a>
                                            <a v-can="'check_registers.create'" title="Check Register" href="javascript:void(0)" class="text-primary me-2" @click.prevent="viewRegister(asset, 'user_check/create')"><i class="ri-calendar-check-fill fs-18 lh-1"></i></a>
                                        </td>
                                    </tr>
                                    <tr v-if="assets.length==0">
                                        <td colspan="10" class="text-center">No records found</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                    <!-- Location Update Modal -->
                        <div class="modal fade" id="locationModal" tabindex="-1" aria-hidden="true">
                            <div class="modal-dialog modal-dialog-centered">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title">Update Asset Location</h5>
                                        <button
                                            type="button"
                                            class="btn-close"
                                            data-bs-dismiss="modal"
                                            aria-label="Close"
                                        ></button>
                                    </div>
                                    <div class="modal-body">
                                        <div class="mb-3">
                                            <label class="form-label">Latitude</label>
                                            <input
                                                type="text"
                                                class="form-control"
                                                v-model="locationForm.latitude"
                                                :class="{ 'is-invalid': errors.latitude }"
                                                placeholder="e.g. 19.0760"
                                            />
                                            <span v-if="errors.latitude" class="invalid-feedback">{{ errors.latitude[0] }}</span>
                                        </div>

                                        <div class="mb-3">
                                            <label class="form-label">Longitude</label>
                                            <input
                                                type="text"
                                                class="form-control"
                                                v-model="locationForm.longitude"
                                                :class="{ 'is-invalid': errors.longitude }"
                                                placeholder="e.g. 72.8777"
                                            />
                                            <span v-if="errors.longitude" class="invalid-feedback">{{ errors.longitude[0] }}</span>
                                        </div>

                                        <div class="mb-3">
                                            <label class="form-label">Radius (in meters)</label>
                                            <input
                                                type="number"
                                                class="form-control"
                                                v-model="locationForm.radius"
                                                min="1"
                                                :class="{ 'is-invalid': errors.radius }"
                                                placeholder="e.g. 50"
                                            />
                                            <span v-if="errors.radius" class="invalid-feedback">{{ errors.radius[0] }}</span>
                                        </div>

                                        <div class="text-end">
                                            <button
                                                type="button"
                                                class="btn btn-sm btn-outline-primary"
                                                @click="getCurrentLocation"
                                            >
                                                <i class="ri-gps-line"></i> Use My Current Location
                                            </button>
                                        </div>
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                                            Cancel
                                        </button>
                                        <button
                                            type="button"
                                            class="btn btn-primary"
                                            @click="updateLocation"
                                            :disabled="locationLoading"
                                        >
                                            <span v-if="locationLoading">Saving...</span>
                                            <span v-else>Update Location</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    <!-- Upload Validation Errors Modal -->
                        <div class="modal fade" id="uploadErrorsModal" tabindex="-1" aria-hidden="true">
                            <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title">Upload Validation Errors</h5>
                                        <button
                                            type="button"
                                            class="btn-close"
                                            data-bs-dismiss="modal"
                                            aria-label="Close"
                                        ></button>
                                    </div>
                                    <div class="modal-body">
                                        <p v-if="uploadSummary" class="text-muted mb-3">{{ uploadSummary }}</p>
                                        <div class="table-responsive">
                                            <table class="table table-sm table-bordered table-striped mb-0">
                                                <thead>
                                                    <tr style="background-color: #9b9b9b; color: white;">
                                                        <th>Row</th>
                                                        <th>Asset Code</th>
                                                        <th>Asset Name</th>
                                                        <th>Error</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(err, idx) in uploadValidationErrors" :key="idx">
                                                        <td>{{ err.row_no }}</td>
                                                        <td>{{ err.asset_code || '-' }}</td>
                                                        <td>{{ err.asset_name || '-' }}</td>
                                                        <td class="text-danger">{{ err.message }}</td>
                                                    </tr>
                                                    <tr v-if="uploadValidationErrors.length === 0">
                                                        <td colspan="4" class="text-center">No validation errors found.</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                                            Close
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="d-flex justify-content-between align-items-center">
                            <select class="form-select form-select-sm width-75" v-model="meta.per_page" @change="onPerPageChange">
                                <option>10</option>
                                <option>15</option>
                                <option>20</option>
                                <option>25</option>
                                <option>30</option>
                            </select>
                            <span>
                                Showing {{ meta.from }} to {{ Math.min(meta.to, meta.totalRows) }} of {{ meta.totalRows }} entries
                            </span>
                            <Pagination :maxPage="meta.maxPage" :totalPages="meta.lastPage" :currentPage="meta.page" @pagechanged="onPageChange" />
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from "axios";
    import Pagination from "@/components/Pagination.vue";
    export default {
        components: {
            Pagination,
        },
        data() {
            return {
                meta: {
                    search: "",
                    order_by: "asc",
                    keyword: "asset_id",
                    per_page: 10,
                    totalRows: 0,
                    page: 1,
                    lastPage: 1,
                    from: 1,
                    to: 1,
                    maxPage: 1,
                    trashed: false,
                    department_id:'',
                    asset_type_id: ''
                },
                get_assetviews: [],
                get_asset: [],
                goto_registers:[],
                assets: [],
                departments:[],
                asset_types: [],
                errors: [],
                downloaded_excel: [],
                selectedFile: null,
                selectedFileName: '',
                status: true,
                locationForm: {
                    asset_id: null,
                    latitude: '',
                    longitude: '',
                    radius: ''
                },
                locationLoading: false,
                locationModal: null,
                uploadValidationErrors: [],
                uploadSummary: '',
                uploadErrorsModal: null
            };
        },
        computed: {
            canDownloadPlantAssetsExcel() {
                const roleName = this.$store.getters.user?.role?.role;
                return roleName === "Super Admin" || roleName === "Admin";
            },
        },
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                if(from.name != 'Assets.Edit' && from.name != 'Assets.View'){
                    vm.$store.commit("setCurrentPage", vm.meta.page)
                }else{
                    vm.meta.page = vm.$store.getters.current_page
                }
            });
        },
        mounted() {
            this.assetviews = this.$store.getters.permissions.filter(function (element) {
                return element.ability.ability.includes("assetviews.details");
            });

            this.get_asset = this.$store.getters.permissions.filter(function (element) {
                return ["assets.update", "assetviews.details", "asset_permanent.delete","assetLocations.update"].some(permission => element.ability.ability.includes(permission));
            });

            this.goto_registers = this.$store.getters.permissions.filter(function (element) {
                return ["activity_registers.create", "service_registers.create", "check_registers.create"].some(permission => element.ability.ability.includes(permission));
            });
            this.$store.commit("setAssetId", '');
            this.index();
            this.getDepartments();
            this.getAssetTypes();
        },

        methods: {
            index() {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "paginateAssets", data: vm.meta })
                    .then((response) => {
                        loader.hide();
                        vm.assets = response.data.data;
                        vm.meta.totalRows = response.data.meta.total;
                        vm.meta.from = response.data.meta.from;
                        const end = vm.meta.from + Number(vm.meta.per_page) - 1;
                        vm.meta.to = end > vm.meta.totalRows ? vm.meta.totalRows : end;
                        vm.meta.lastPage = response.data.meta.last_page;
                        vm.meta.maxPage = vm.meta.lastPage >= 3 ? 3 : vm.meta.lastPage;
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            getDepartments() {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "getDepartments" })
                    .then((response) => {
                        loader.hide();
                        vm.departments = response.data.data;
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            getAssetTypes() {
                let vm = this;
                vm.$store
                    .dispatch("post", { uri: "getAssetTypes" })
                    .then((response) => {
                        vm.asset_types = response.data.data;
                    })
                    .catch(function (error) {
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            downloadExcel() {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "downloadAssets", data: vm.meta })
                    .then((response) => {
                        loader.hide();
                        vm.$store.dispatch("success", response.data.message);
                        vm.downloaded_excel = response.data;
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            downloadAssetFormat() {
                const vm = this;
                if (!vm.meta.asset_type_id) {
                    vm.$store.dispatch("error", "Please select an Asset Type to download the format.");
                    return;
                }
                const loader = vm.$loading.show();
                axios
                    .post(
                        vm.$store.state.apiUrl + "downloadAssetFormat",
                        { asset_type_id: vm.meta.asset_type_id },
                        {
                            headers: {
                                Authorization: "Bearer " + vm.$store.getters.token,
                                Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                            },
                            responseType: "blob",
                        }
                    )
                    .then((response) => {
                        loader.hide();
                        const type =
                            response.headers["content-type"] ||
                            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
                        const blob = new Blob([response.data], { type });
                        const url = window.URL.createObjectURL(blob);
                        const a = document.createElement("a");
                        a.href = url;
                        const cd = response.headers["content-disposition"];
                        let filename = "asset_format.xlsx";
                        if (cd && cd.includes("filename=")) {
                            const match = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/i.exec(cd);
                            if (match && match[1]) {
                                filename = match[1].replace(/['"]/g, "").trim();
                            }
                        }
                        a.download = filename;
                        document.body.appendChild(a);
                        a.click();
                        a.remove();
                        window.URL.revokeObjectURL(url);
                        vm.$store.dispatch("success", "Asset format downloaded.");
                    })
                    .catch((error) => {
                        loader.hide();
                        const res = error.response;
                        if (res?.data instanceof Blob) {
                            res.data.text().then((text) => {
                                try {
                                    const json = JSON.parse(text);
                                    vm.$store.dispatch("error", json.message || "Download failed.");
                                } catch {
                                    vm.$store.dispatch("error", "Download failed.");
                                }
                            });
                        } else {
                            vm.$store.dispatch("error", res?.data?.message || error.message || "Download failed.");
                        }
                    });
            },
            onAssetFileSelect(event) {
                const vm = this;
                const file = event.target.files[0];

                if (!file) {
                    vm.selectedFileName = '';
                    vm.selectedFile = null;
                    return;
                }

                const validTypes = [
                    'application/vnd.ms-excel',
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    'text/csv'
                ];
                const validExtensions = ['.xls', '.xlsx', '.csv'];
                const fileExtension = '.' + file.name.split('.').pop().toLowerCase();

                if (!validTypes.includes(file.type) && !validExtensions.includes(fileExtension)) {
                    vm.$store.dispatch("error", "Please upload a valid Excel or CSV file.");
                    vm.$refs.uploadAssetFile.value = '';
                    vm.selectedFileName = '';
                    vm.selectedFile = null;
                    return;
                }

                vm.selectedFileName = file.name;
                vm.selectedFile = file;
            },
            uploadAssetExcel() {
                const vm = this;

                if (!vm.selectedFile) {
                    vm.$store.dispatch("error", "Please select a file first.");
                    return;
                }

                const loader = vm.$loading.show();
                const formData = new FormData();
                formData.append('file', vm.selectedFile);

                vm.$store
                    .dispatch("post", { uri: "uploadAssets", data: formData })
                    .then((response) => {
                        loader.hide();
                        const createdCount = response.data.created_count ?? response.data.created ?? 0;
                        const failedCount = response.data.failed_count ?? response.data.skipped ?? 0;
                        const validationErrors = response.data.validation_errors || [];

                        if (validationErrors.length > 0) {
                            vm.handleUploadValidationErrors(validationErrors, response.data.message);
                        }

                        if (createdCount > 0) {
                            vm.$store.dispatch("success", createdCount + " asset(s) created successfully.");
                        }

                        if (failedCount > 0) {
                            vm.$store.dispatch("error", failedCount + " row(s) failed. Please review the validation errors.");
                        } else if (createdCount === 0 && validationErrors.length === 0) {
                            vm.$store.dispatch("success", response.data.message || "Upload completed.");
                        }

                        vm.resetUploadFile();
                        if (createdCount > 0) {
                            vm.index();
                        }
                    })
                    .catch(function (error) {
                        loader.hide();
                        const responseData = error.response?.data || {};
                        const validationErrors =
                            responseData.validation_errors ||
                            vm.formatRequestValidationErrors(responseData.errors);
                        const message = responseData.message || "Failed to upload assets.";

                        if (validationErrors.length > 0) {
                            vm.handleUploadValidationErrors(validationErrors, message);
                        }

                        vm.errors = responseData.errors || [];
                        vm.$store.dispatch("error", message);
                        vm.resetUploadFile();
                    });
            },
            formatRequestValidationErrors(errors) {
                if (!errors || typeof errors !== "object") {
                    return [];
                }
                return Object.entries(errors).flatMap(([field, messages]) => {
                    const list = Array.isArray(messages) ? messages : [messages];
                    return list.map((msg) => ({
                        row_no: "-",
                        asset_code: "",
                        asset_name: field.replace(/_/g, " "),
                        status: "Failed",
                        message: msg,
                    }));
                });
            },
            showUploadErrorsModal() {
                if (!this.uploadErrorsModal) {
                    this.uploadErrorsModal = new bootstrap.Modal(document.getElementById("uploadErrorsModal"));
                }
                this.uploadErrorsModal.show();
            },
            handleUploadValidationErrors(errors, summary = "") {
                this.uploadValidationErrors = Array.isArray(errors) ? errors : [];
                this.uploadSummary = summary;
                this.showUploadErrorsModal();
            },
            resetUploadFile() {
                if (this.$refs.uploadAssetFile) {
                    this.$refs.uploadAssetFile.value = "";
                }
                this.selectedFileName = "";
                this.selectedFile = null;
            },
            downloadPlantAssetsExcel() {
                const vm = this;
                const plantId = vm.$store.getters.user?.plant_id;
                if (!plantId) {
                    vm.$store.dispatch("error", "No plant is assigned to your account.");
                    return;
                }
                const loader = vm.$loading.show();
                axios
                    .post(
                        vm.$store.state.apiUrl + "assetsDownload",
                        { plant_id: plantId },
                        {
                            headers: {
                                Authorization: "Bearer " + vm.$store.getters.token,
                                Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                            },
                            responseType: "blob",
                        }
                    )
                    .then((response) => {
                        loader.hide();
                        const type =
                            response.headers["content-type"] ||
                            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
                        const blob = new Blob([response.data], { type });
                        const url = window.URL.createObjectURL(blob);
                        const a = document.createElement("a");
                        a.href = url;
                        const cd = response.headers["content-disposition"];
                        let filename = "assets_plant_" + plantId + "_" + new Date().toISOString().slice(0, 19).replace(/[:T]/g, "-") + ".xlsx";
                        if (cd && cd.includes("filename=")) {
                            const match = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/i.exec(cd);
                            if (match && match[1]) {
                                filename = match[1].replace(/['"]/g, "").trim();
                            }
                        }
                        a.download = filename;
                        document.body.appendChild(a);
                        a.click();
                        a.remove();
                        window.URL.revokeObjectURL(url);
                        vm.$store.dispatch("success", "Plant assets export downloaded.");
                    })
                    .catch((error) => {
                        loader.hide();
                        const res = error.response;
                        if (res?.data instanceof Blob) {
                            res.data.text().then((text) => {
                                try {
                                    const json = JSON.parse(text);
                                    vm.$store.dispatch("error", json.message || "Download failed.");
                                } catch {
                                    vm.$store.dispatch("error", "Download failed.");
                                }
                            });
                        } else {
                            vm.$store.dispatch("error", res?.data?.message || error.message || "Download failed.");
                        }
                    });
            },
            // downloadQRCodes() {
            //     let vm = this;
            //     window.open(
            //         vm.$store.state.apiUrl + 
            //         "downloadAssetQRCodeAll?department_id=" + vm.meta.department_id + "&plant_id=" +vm.$store.getters.user.plant_id
            //     );
            // },
            downloadQRCodes() {
                let vm = this;
                const url = new URL(vm.$store.state.apiUrl + "downloadAssetQRCodeAll");
                url.searchParams.set("department_id", vm.meta.department_id);
                url.searchParams.set("plant_id", vm.$store.getters.user.plant_id);
                if (vm.meta.search) {
                    url.searchParams.set("search", vm.meta.search);
                }
                window.open(url.toString());
            },

            editAsset(asset) {
                this.$store.commit("setCurrentPage", this.meta.page)
                this.$router.push("/asset/" + asset.asset_id + "/edit");
            },
            viewAsset(asset) {
                this.$store.commit("setCurrentPage", this.meta.page)
                this.$router.push("/asset/" + asset.asset_id + "/view");
            },
            viewRegister(asset, path){
                this.$store.commit("setCurrentPage", this.meta.page)
                this.$store.commit("setAssetId", asset.asset_id);
                this.$router.push(path);
            },
            getQRCode(asset) {
                window.open(
                    this.$store.state.apiUrl + "downloadAssetQRCode?asset_code=" + encodeURIComponent(asset.asset_code),
                    "_blank"
                );
            },
            deleteAsset(asset) {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", {
                        uri: "deleteAsset",
                        data: asset,
                    })
                    .then((response) => {
                        loader.hide();
                        vm.$store.dispatch("success", response.data.message);
                        vm.index();
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            
            //New Location Methods
            openLocationModal(asset) {
                this.locationForm.asset_id = asset.asset_id;
                this.locationForm.latitude = asset.latitude || "";
                this.locationForm.longitude = asset.longitude || "";
                this.locationForm.radius = asset.radius || "";

                if (!this.locationModal) {
                    this.locationModal = new bootstrap.Modal(document.getElementById("locationModal"));
                }
                this.locationModal.show();
            },
            getCurrentLocation() {
                console.log(navigator.geolocation);
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        (position) => {
                            this.locationForm.latitude = position.coords.latitude.toFixed(6);
                            this.locationForm.longitude = position.coords.longitude.toFixed(6);
                            this.$store.dispatch("success", "Current location detected!");
                        },
                        (err) => {
                            console.log(err);
                            this.$store.dispatch("error", "Unable to get your location. Please allow location access.");
                        }
                    );
                } else {
                    this.$store.dispatch("error", "Geolocation is not supported by your browser.");
                }
            },
            updateLocation() {
                let vm = this;
                vm.locationLoading = true;
                let loader = vm.$loading.show();

                vm.$store.dispatch("post", { uri: "updateAssetLocation", data: vm.locationForm,})
                .then((response) => {
                    vm.$store.dispatch("success", "Location updated successfully!");
                    vm.index();
                    vm.locationModal.hide();
                })
                .catch((error) => {
                    vm.errors = error.response?.data?.errors || {};
                    vm.$store.dispatch("error", error.response?.data?.message || "Failed to update location");
                })
                .finally(() => {
                    vm.locationLoading = false;
                    loader.hide();
                });
            },
            
            forceDeleteAsset(asset) {
                const confirmDelete = confirm("Are you sure you want to delete it ?");
                if (confirmDelete) {
                    let vm = this;
                    let loader = vm.$loading.show();
                    vm.$store
                        .dispatch("post", {
                            uri: "forceDeleteAsset",
                            data: asset,
                        })
                        .then((response) => {
                            loader.hide();
                            vm.$store.dispatch("success", response.data.message);
                            vm.index();
                        })
                        .catch(function (error) {
                            loader.hide();
                            vm.errors = error.response.data.errors;
                            vm.$store.dispatch("error", error.response.data.message);
                        });
                }
            },
            search() {
                let vm = this;
                vm.meta.page = 1;
                vm.index();
            },

            onPageChange(page) {
                this.meta.page = page;
                this.index();
            },

            onPerPageChange() {
                let vm = this;
                vm.meta.page = 1;
                vm.index();
            },
            sort(field) {
                this.meta.keyword = field;
                this.meta.order_by = this.meta.order_by == "asc" ? "desc" : "asc";
                this.index();
            },
        },
    };
</script>
